module.exports = __webpack_public_path__ + "img/10a3611.jpg";